import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, forwardRef, Directive, Inject, Injectable, APP_INITIALIZER, NgModule } from '@angular/core';
import { Options } from 'ngx-google-places-autocomplete/objects/options/options';
import * as i1 from 'ngx-google-places-autocomplete';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i3 from '@angular/common';
import { DOCUMENT } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { SosCommonUiModule } from 'sos-common-ui';

class GoogleAutocompleteComponent {
    constructor() {
        this.addAddressObjectValidator = false;
        this.addressChange = new EventEmitter();
    }
    ngOnInit() {
        this.options = this.options ?? new Options();
        if (this.addAddressObjectValidator) {
            this.address?.addValidators(this.addressExistsValidator());
        }
        if (this.selectedAddress) {
            this.address?.setValue(this.selectedAddress.formatted_address);
        }
        console.warn("Warning. This component is deprecated and will meets its just demise in the near future");
    }
    changeAddress(event) {
        this.selectedAddress = event;
        this.addressChange.emit(event);
        this.address?.setValue(event.formatted_address);
    }
    clearAddress() {
        this.selectedAddress = undefined;
        this.addressChange.emit(undefined);
        this.address?.setValue('');
        this.address?.markAsPristine();
    }
    addressExistsValidator() {
        return (control) => {
            return this.selectedAddress ? null : { missingAddress: { value: this.selectedAddress } };
        };
    }
}
GoogleAutocompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: GoogleAutocompleteComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
GoogleAutocompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: GoogleAutocompleteComponent, selector: "google-autocomplete", inputs: { address: "address", selectedAddress: "selectedAddress", options: "options", addAddressObjectValidator: "addAddressObjectValidator", placeHolder: "placeHolder", errorMessage: "errorMessage" }, outputs: { addressChange: "addressChange" }, ngImport: i0, template: "<div class=\"input-group merge-border\">\n  <input ngx-google-places-autocomplete\n         type = text\n         class=\"form-control text-18 adaptive-padding sos-style bg-disabled-white\"\n         (onAddressChange)=\"changeAddress($event)\"\n         [options]=\"options\"\n         [formControl]=\"address\"\n         [readOnly]=\"selectedAddress\"\n         [placeholder]=\"placeHolder\"/>\n  <button *ngIf=\"selectedAddress\" class=\"btn sos-style cross-button\" (click)=\"clearAddress()\"></button>\n</div>\n<span class=\"text-danger\" *ngIf=\"address.dirty && address.touched && address.errors\">\n  {{ errorMessage }}\n</span>\n", dependencies: [{ kind: "directive", type: i1.GooglePlaceDirective, selector: "[ngx-google-places-autocomplete]", inputs: ["options"], outputs: ["onAddressChange"], exportAs: ["ngx-places"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: GoogleAutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'google-autocomplete', template: "<div class=\"input-group merge-border\">\n  <input ngx-google-places-autocomplete\n         type = text\n         class=\"form-control text-18 adaptive-padding sos-style bg-disabled-white\"\n         (onAddressChange)=\"changeAddress($event)\"\n         [options]=\"options\"\n         [formControl]=\"address\"\n         [readOnly]=\"selectedAddress\"\n         [placeholder]=\"placeHolder\"/>\n  <button *ngIf=\"selectedAddress\" class=\"btn sos-style cross-button\" (click)=\"clearAddress()\"></button>\n</div>\n<span class=\"text-danger\" *ngIf=\"address.dirty && address.touched && address.errors\">\n  {{ errorMessage }}\n</span>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { address: [{
                type: Input
            }], selectedAddress: [{
                type: Input
            }], options: [{
                type: Input
            }], addAddressObjectValidator: [{
                type: Input
            }], placeHolder: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }], addressChange: [{
                type: Output
            }] } });

/// <reference types="@types/google.maps" />
/// <reference types="@types/google.maps" />
class GoogleAutocompleteDirective {
    constructor(hostElement, ngZone, renderer, document, changeDetectorRef) {
        this.hostElement = hostElement;
        this.ngZone = ngZone;
        this.renderer = renderer;
        this.document = document;
        this.changeDetectorRef = changeDetectorRef;
        this.locked = false;
        this.propagateChange = (next) => { };
        this.onTouched = () => { };
    }
    writeValue(newItem) {
        this.decideLock(newItem);
        if (newItem) {
            this.renderer.setProperty(this.hostElement.nativeElement, 'value', newItem.formatted_address);
        }
    }
    overrideOnChange(original) {
        const override = (next) => {
            if (next === null) {
                this.renderer.setProperty(this.hostElement.nativeElement, 'value', "");
            }
            else {
                this.renderer.setProperty(this.hostElement.nativeElement, 'value', next.formatted_address);
            }
            this.decideLock(next);
            original(next);
        };
        return override;
    }
    registerOnChange(fn) {
        this.propagateChange = this.overrideOnChange(fn);
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.renderer.setProperty(this.hostElement.nativeElement, 'disabled', isDisabled);
    }
    ngOnInit() {
        this.renderer.setAttribute(this.hostElement.nativeElement, 'type', 'search');
    }
    ngAfterViewInit() {
        if (!this.options) {
            this.options = {};
        }
        if (!this.options.fields) {
            this.options.fields = ["address_component", "adr_address", "business_status", "formatted_address", "geometry", "icon", "name",
                "photo", "place_id", "plus_code", "type", "url", "utc_offset_minutes", "vicinity", "wheelchair_accessible_entrance"];
        }
        this.removeSearchListener = this.renderer.listen(this.hostElement.nativeElement, 'search', this.handleSearchEvent.bind(this));
        this.removeInputListener = this.renderer.listen(this.hostElement.nativeElement, 'input', this.handleInputEvent.bind(this));
        this.removeKeyDownListener = this.renderer.listen(this.hostElement.nativeElement, 'keydown', this.handleKeyDownEvent.bind(this));
        this.initializeGPAC();
    }
    isGoogleLibExists() {
        return !(!google || !google.maps || !google.maps.places);
    }
    initializeGPAC() {
        if (!this.isGoogleLibExists()) {
            throw new Error("Google maps library can not be found");
        }
        this.autocomplete = new google.maps.places.Autocomplete(this.hostElement.nativeElement, this.options);
        if (!this.autocomplete) {
            throw new Error("Autocomplete is not initialized");
        }
        this.eventListener = this.autocomplete.addListener("place_changed", () => {
            const place = this.autocomplete?.getPlace();
            if (!place?.geometry || !place?.geometry.location) {
                window.alert("No details available for input: '" + place?.name + "'");
                return;
            }
            this.propagateChange(place);
        });
    }
    ngOnDestroy() {
        if (this.autocomplete && this.eventListener) {
            this.eventListener.remove();
        }
        if (this.removeSearchListener) {
            this.removeSearchListener();
        }
        if (this.removeInputListener) {
            this.removeInputListener();
        }
        if (this.removeKeyDownListener) {
            this.removeKeyDownListener();
        }
    }
    clearData() {
        this.propagateChange(null);
    }
    decideLock(next) {
        if (next != null) {
            this.locked = true;
        }
        else {
            this.locked = false;
        }
    }
    handleSearchEvent(input) {
        if (!input.value) {
            this.propagateChange(null);
        }
    }
    handleInputEvent(event) {
        const value = event?.target?.value;
        if (!value) {
            this.propagateChange(null);
        }
    }
    handleKeyDownEvent(event) {
        if (this.locked) {
            if (["backspace", "delete"].includes(event.key.toLowerCase())) {
                this.propagateChange(null);
            }
            else if (!["arrowright", "arrowleft"].includes(event.key.toLowerCase())) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        }
    }
}
GoogleAutocompleteDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: GoogleAutocompleteDirective, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }, { token: i0.Renderer2 }, { token: DOCUMENT }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive });
GoogleAutocompleteDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.9", type: GoogleAutocompleteDirective, selector: "input[scu-google-autocomplete]", inputs: { options: "options" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => GoogleAutocompleteDirective),
            multi: true
        }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: GoogleAutocompleteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[scu-google-autocomplete]',
                    providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => GoogleAutocompleteDirective),
                            multi: true
                        }]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }, { type: i0.Renderer2 }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { options: [{
                type: Input
            }] } });

class SOSCommonGoogleConfig {
    constructor() {
        this.googleAPIKey = undefined;
        this.gTag = '';
    }
}
SOSCommonGoogleConfig.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SOSCommonGoogleConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SOSCommonGoogleConfig.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SOSCommonGoogleConfig, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SOSCommonGoogleConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class SosCommonUiGoogleModule {
    static forRoot(sosCommonUIParams) {
        return {
            ngModule: SosCommonUiGoogleModule,
            providers: [
                {
                    provide: SOSCommonGoogleConfig,
                    useValue: sosCommonUIParams
                }
            ]
        };
    }
}
SosCommonUiGoogleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SosCommonUiGoogleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SosCommonUiGoogleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: SosCommonUiGoogleModule, declarations: [GoogleAutocompleteComponent,
        GoogleAutocompleteDirective], imports: [GooglePlaceModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        SosCommonUiModule], exports: [GoogleAutocompleteComponent,
        GoogleAutocompleteDirective] });
SosCommonUiGoogleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SosCommonUiGoogleModule, providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: setHeader,
            deps: [SOSCommonGoogleConfig],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: setGoogleTagManager,
            multi: true,
            deps: [SOSCommonGoogleConfig],
        },
    ], imports: [GooglePlaceModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        SosCommonUiModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SosCommonUiGoogleModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GoogleAutocompleteComponent,
                        GoogleAutocompleteDirective
                    ],
                    imports: [
                        GooglePlaceModule,
                        FormsModule,
                        ReactiveFormsModule,
                        BrowserModule,
                        SosCommonUiModule
                    ],
                    providers: [
                        {
                            provide: APP_INITIALIZER,
                            useFactory: setHeader,
                            deps: [SOSCommonGoogleConfig],
                            multi: true
                        },
                        {
                            provide: APP_INITIALIZER,
                            useFactory: setGoogleTagManager,
                            multi: true,
                            deps: [SOSCommonGoogleConfig],
                        },
                    ],
                    exports: [
                        GoogleAutocompleteComponent,
                        GoogleAutocompleteDirective
                    ]
                }]
        }] });
function setHeader(moduleConfig) {
    return () => {
        return new Promise((resolve, reject) => {
            let googleScript = document.createElement('script');
            googleScript.src = 'https://maps.googleapis.com/maps/api/js?key=' + moduleConfig.googleAPIKey + '&libraries=places,geocoding&callback=initGoogle';
            googleScript.type = 'text/javascript';
            googleScript.async = false;
            const headTag = document.getElementsByTagName('head')[0];
            const scriptTags = headTag.getElementsByTagName("script");
            for (let i = 0; i < scriptTags.length; i++) {
                const scriptTag = scriptTags.item(i);
                if (scriptTag && scriptTag.src.indexOf('maps.googleapis.com/maps/api/js') > 0) {
                    reject("This module sets its own script to import google apis. Don't hardcode it or set it otherwise");
                    return;
                }
            }
            googleScript.onload = (ev) => {
                resolve();
            };
            // @ts-ignore
            window.initGoogle = () => {
                //This is just to make google stop complaining about missing a callback
                console.log("Google components loaded");
            };
            headTag.appendChild(googleScript);
        });
    };
}
;
function setGoogleTagManager(moduleConfig) {
    return () => {
        return new Promise((resolve, reject) => {
            let googleScript = document.createElement('script');
            const gTag = moduleConfig.gTag || null;
            googleScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + gTag;
            googleScript.type = 'text/javascript';
            googleScript.async = false;
            const headTag = document.getElementsByTagName('head')[0];
            googleScript.onload = (ev) => {
                // @ts-ignore
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    // @ts-ignore
                    window.dataLayer.push(arguments);
                }
                // @ts-ignore
                gtag('js', new Date());
                if (gTag !== null && gTag !== '') {
                    // Only configure if gTag is provided.
                    // @ts-ignore  
                    gtag('config', moduleConfig.gTag);
                }
                resolve();
            };
            headTag.appendChild(googleScript);
        });
    };
}
;

/*
 * Public API Surface of sos-common-ui-google
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GoogleAutocompleteComponent, GoogleAutocompleteDirective, SOSCommonGoogleConfig, SosCommonUiGoogleModule, setGoogleTagManager, setHeader };
